import EFPicture from 'elem/compCommon/EFPicture';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFKitC3SvgH5Us, EFKitC3SvgH5Au, EFKitC6SvgH5, EFKitC7SvgH5 } from '@/components/UI/svg/mm100';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/h5/');

function ChildComp(props: any) {
    const boxClass = `base-box ${props.customClass}`;

    return (
        <div className={boxClass}>
            <EFPic name={props.imgSrc} className="fullImgs" alt="" />
            {!!props.moreTitle ? (
                <div className="v-msg">
                    {props.titleList.map((item: string, index: number) => (
                        <div key={item} className={`v-msg-title${index + 1}`}>
                            {item}
                        </div>
                    ))}
                </div>
            ) : (
                <div className="v-msg">{props.titleText}</div>
            )}
        </div>
    );
}

export default function Comp({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const { locale } = useRouter();

    return (
        <div className={`${css.kitC} kitC`}>
            {locale === 'au' ? (
                <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1722828546639/mm100_view_au_h5.png" alt={t('presale.product.KitC_title')} />
            ) : (
                <div className="kit-box">
                    <ChildComp customClass="top-box" imgSrc={['KitC1.webp', 'KitC1.jpg']} titleText={t('presale.product.KitC1_ms1')} />
                    <div className="mid-top">
                        <ChildComp customClass="mid-top__left" imgSrc={['KitC2.webp', 'KitC2.jpg']} titleText={t('presale.product.KitC2_ms1')} />
                        <ChildComp customClass="mid-top__right" imgSrc={['KitC5.webp', 'KitC5.jpg']} titleText={t('presale.product.KitC5_ms1')} />
                    </div>
                    <div className="mid-bottom">
                        <ChildComp
                            customClass="mid-bottom__left"
                            imgSrc={['KitC4.webp', 'KitC4.jpg']}
                            moreTitle={true}
                            titleList={[t('presale.product.KitC4_ms1'), t('presale.product.KitC4_ms2')]}
                        />
                        <div className="base-box mid-bottom__right">
                            {locale !== 'au' ? (
                                <EFKitC3SvgH5Us width="2.14rem" height="1.35rem" className="svg-class" />
                            ) : (
                                <EFKitC3SvgH5Au width="2.14rem" height="1.35rem" className="svg-class" />
                            )}
                            <div className="v-msg">
                                <div className="v-msg-title1">{t('presale.product.KitC3_ms1')}</div>
                                <div className="v-msg-title2">{t('presale.product.KitC3_ms2')}</div>
                            </div>
                        </div>
                    </div>
                    <div className="bottom-box__new" style={{ display: locale === 'us' ? 'flex' : 'none' }}>
                        <div className="base-box bottom-box__left">
                            <EFKitC6SvgH5 className="kitc6-svg" />
                            <div className="v-msg-title1">{t('presale.product.KitC6_ms1_new')}</div>
                            <div className="v-msg-title2">{t('presale.product.KitC6_ms2_new')}</div>
                        </div>
                        <div className="base-box bottom-box__right">
                            <EFKitC7SvgH5 className="kitc7-svg" />
                            <div className="v-msg v-msg-title1">{t('presale.product.KitC7_ms1_new')}</div>
                        </div>
                    </div>
                    <div className="bottom-box" style={{ display: locale !== 'us' ? 'flex' : 'none' }}>
                        <ChildComp customClass="bottom-box__left" imgSrc={['KitC6.webp', 'KitC6.jpg']} titleText={t('presale.product.KitC6_ms1')} />
                        <ChildComp customClass="bottom-box__right" imgSrc={['KitC7.webp', 'KitC7.jpg']} titleText={t('presale.product.KitC7_ms1')} />
                    </div>
                </div>
            )}
            <div className="kit-text">{t('presale.product.KitC_title')}</div>
        </div>
    );
}
